<template>
  <div class="page">
    <div class="public-wrap">
      <img src="@/assets/images/misc/pay.png" alt="" class="pay-art" />
      <h1>{{ $t('public_pay_title') }}</h1>
      <p class="lead">{{ $t('public_pay_body') }}</p>
      <div class="brands">
        <img src="@/assets/images/logos/master.png" alt="Mastercard" />
        <img src="@/assets/images/logos/stripe-account.png" alt="Stripe" />
        <img src="@/assets/images/logos/google.png" alt="Google Pay" />
      </div>
      <v-btn color="primary" class="mt-6" depressed to="/register/family">
        {{ $t('sign_up') }}
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.page { padding: 48px 0 80px; }
.public-wrap { width: min(640px, calc(100% - 32px)); margin: 0 auto; }
.pay-art { width: min(280px, 100%); display: block; margin-bottom: 16px; }
.lead { color: #5a4636; font-size: 1.1rem; }
.brands { display: flex; align-items: center; gap: 18px; margin-top: 20px; flex-wrap: wrap; }
.brands img { height: 36px; object-fit: contain; }
</style>
